export default __webpack_public_path__ + "static/media/codefund.b97577e3.svg";